import { stringOrNull } from "../../utils/string-or-null.util";

export class FrenchUfValuesWindow {
  systemName: string;
  outerFrame: string | null;
  ventFrame1: string | null;
  mullion: string | null;
  ventFrame2: string | null;
  insuLevel: string | null;
  lf1: number | null;
  lf2: number | null;
  lf: number | null;
  uf: number | null;
  outerFrameFoam: string | null;
  ventFrameFoam: string | null;
  mullionFoam: string | null;
  rebateFoam: string | null;
  centraFoam: string | null;
  
  constructor(row: Record<string, string | number | null>) {
    this.systemName = row['systemName'] as string;
    this.outerFrame = stringOrNull(row['outerFrame']) as string | null;
    this.ventFrame1 = stringOrNull(row['ventFrame1']) as string | null;
    this.mullion = stringOrNull(row['mullion']) as string | null;
    this.ventFrame2 = stringOrNull(row['ventFrame2']) as string | null;
    this.insuLevel = row['insuLevel'] as string | null;
    this.lf1 = row['lf1'] as number | null;
    this.lf2 = row['lf2'] as number | null;
    this.lf = row['lf'] as number | null;
    this.uf = row['uf'] as number | null;
    this.outerFrameFoam = stringOrNull(row['outerFrameFoam']) as string | null;
    this.ventFrameFoam = stringOrNull(row['ventFrameFoam']) as string | null;
    this.mullionFoam = stringOrNull(row['mullionFoam']) as string | null;
    this.rebateFoam = stringOrNull(row['rebateFoam']) as string | null;
    this.centraFoam = stringOrNull(row['centraFoam']) as string | null;
  }
}